import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-registration-success-modal',
  templateUrl: './registration-success-modal.component.html',
  styleUrls: ['./registration-success-modal.component.scss']
})
export class RegistrationSuccessModalComponent implements OnInit {
  @Input() message: string = '';
  @Input() isSuccess: boolean = true;
  @Input() loading: boolean = false;

  serverMessageHtml = '';

  constructor(
    protected dialogRef: NbDialogRef<RegistrationSuccessModalComponent>,
    private router: Router
  ) {}

  ngOnInit(): void {
    const fallback =
      'Your account has been successfully registered. Please check your inbox and follow the instructions in the verification email to activate your account.';
    this.serverMessageHtml = this.message?.trim() ? this.message : fallback;
  }

  goToLogin(): void {
    this.dialogRef.close(true);
    this.router.navigate(['/']);
  }
}

